//PRE FORMATTING
const parseMapOrJsonUiConfig = (jsonOrMapFields, property, defaultValue) => {
    let { name } = property;
    try {
        let value = [];
        let uiconfig = JSON.parse(property.uiconfig);
        let stringValue = defaultValue;
        if (uiconfig.type === "MAP") {
            jsonOrMapFields[name?.toLowerCase()] = uiconfig;
            if (stringValue) {
                let rows = stringValue?.split(uiconfig.rowDelimiter);
                rows.forEach(row => {
                    let kv = row.split(uiconfig.columnDelimiter);
                    value.push({
                        key: kv[0].trim(),
                        value: kv[1]
                    });
                });
                return value;
            }
        }
        if (uiconfig.type === "JSON") {
            jsonOrMapFields[name?.toLowerCase()] = uiconfig;
            if (stringValue) {
                let JSONValue = JSON.parse(stringValue);
                for (let key in JSONValue) {
                    value.push({
                        key: key.trim(),
                        value: JSONValue[key]
                    });
                }
                return value;
            }
        }
        return null;
    } catch (error) {
        console.log("error is ", error);
        return null;
    }
};

//POST FORMATTING
const processMapAndJsonValue = (jsonOrMapFields, key, values) => {
    let UIConfig = jsonOrMapFields[key?.toLowerCase()];
    if (typeof UIConfig === "string") {
        UIConfig = JSON.parse(UIConfig);
    }
    if (UIConfig.type === "MAP") {
        let strings = [];
        values.forEach(entry => {
            if (entry && entry["key"] && entry["value"] !== null && entry["value"] !== "") {
                strings.push([entry["key"], entry["value"]].join(UIConfig.columnDelimiter));
            }
        });
        let value = strings.join(UIConfig.rowDelimiter);
        return value;
    }
    if (UIConfig.type === "JSON") {
        let storedValue = {};
        values.forEach(entry => {
            if (entry && entry["key"] && entry["value"] !== null && entry["value"] !== "") {
                storedValue[entry["key"]] = entry["value"];
            }
        });
        return JSON.stringify(storedValue);
    }
    return "";
};

export { parseMapOrJsonUiConfig, processMapAndJsonValue };
